import React, { useState, useContext } from "react";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import CardWrap from "../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { certificateService } from "../../Services/certificate.service";
import ResultModal from "../Common/ResultModal";
import DatePicker, { registerLocale } from "react-datepicker";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import * as dateHelper from "../../Helpers/DateHelper";
import Tooltip from "../Common/Tooltip";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { lettersAndNumbers } from "../../Config/Regex";
registerLocale("hr", hr);
registerLocale("en", en);

const CertificateMiniUpload = () => {
  const { locName, locTenant, selectedLanguageId } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [fileValidation, setFileValidation] = useState("");
  const [certificate, setCertificate] = useState({
    tenantId: locTenant
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  let formData = new FormData();

  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCertificate({ ...certificate, [name]: value });
  };

  const handleFileChange = (event) => {
    setFileValidation("");
    /*if (event.target.files[0].type != "application/x-pkcs12") {
      document.getElementsByName("file")[0].value = null;
      setFileValidation("Certifikat mora biti u P12 formatu.");
      return false;
    }*/
  };
  const handleFileKeyChange = (event) => {
    setFileValidation("");
    /*if (event.target.files[0].type != "application/x-pkcs12") {
      document.getElementsByName("fileKey")[0].value = null;
      setFileValidation("Certifikat mora biti u P12 formatu.");
      return false;
    }*/
  };

  const onSubmit = () => {
    if (!document.getElementsByName("file")[0].value) {
      setFileValidation("Unos certifikata je obavezan!");
      return false;
    }

    formData.append("tenantId", Number(certificate.tenantId));
    formData.append(
      "fileContent",
      document.getElementsByName("file")[0].files[0]
    );
    formData.append(
      "fileKey",
      document.getElementsByName("fileKey")[0].files[0]
    );
   

    certificateService
      .uploadMiniCert(formData)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("CertificateUpload-SuccesModal-Title"),
              text: translator("CertificateUpload-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("CertificateUpload-UnsuccesModal-Title"),
              text: translator("CertificateUpload-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("CertificateUpload-UnsuccesModal-Title"),
          text: translator("CertificateUpload-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    goBack();
  };
  return (
    <CardWrap subtitle={translator("Certificate-Upload-Title")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Certificate-Upload-Legend")}
            </legend>

           
            <div className="form-group">
              <label>{translator("Certificate-Upload-File")}</label>
              <input
                type="file"
                className="form-control-file"
                name="file"
                onChange={handleFileChange}
              />
              <p className="text-danger">{fileValidation}</p>
            </div>

            <div className="form-group">
              <label>{translator("Certificate-Upload-File")}</label>
              <input
                type="file"
                className="form-control-file"
                name="fileKey"
                onChange={handleFileKeyChange}
              />
              <p className="text-danger">{fileValidation}</p>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">          
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default CertificateMiniUpload;
